import React from "react";
import { Form, Card } from "react-bootstrap";
import "./SheetSelector.css";

// Define categories for sheet types
const SHEET_CATEGORIES = {
  Academic: ["All", "Curriculum", "Course", "Subject", "Syllabus"],
  Student: ["Batch", "Student"],
  Staff: ["Department", "Designation", "Employee"],
};

interface SheetSelectorProps {
  availableSheets: string[];
  selectedSheets: string[];
  onChange: (sheets: string[]) => void;
  disabled?: boolean;
}

const SheetSelector: React.FC<SheetSelectorProps> = ({
  availableSheets,
  selectedSheets,
  onChange,
  disabled = false,
}) => {

  const handleCheckboxChange = (sheet: string) => {
    if (disabled) return;

    if (sheet === "All") {
      // If "All" is being selected
      if (!selectedSheets.includes("All")) {
        onChange(["All"]);
      }
    } else {
      // Handle selection of other sheets
      let newSelection: string[];

      if (selectedSheets.includes(sheet)) {
        // Remove the sheet if it's already selected
        newSelection = selectedSheets.filter((s) => s !== sheet);
        if (newSelection.length === 0) {
          // If all sheets were deselected, select "All" by default
          newSelection = ["All"];
        }
      } else {
        // Add the sheet and remove "All" if it was selected
        newSelection = selectedSheets.includes("All")
          ? [sheet] // Replace "All" with the new selection
          : [...selectedSheets, sheet]; // Add to existing selection
      }

      onChange(newSelection);
    }
  };

  return (
    <div className="sheet-selector-container">
      {availableSheets.map((sheet) => (
        <Card
          key={sheet}
          className={`sheet-selector-item ${
            selectedSheets.includes(sheet) ? "selected" : ""
          } ${disabled ? "disabled" : ""}`}
          onClick={() => handleCheckboxChange(sheet)}
        >
          <Card.Body className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              id={`sheet-${sheet}`}
              checked={selectedSheets.includes(sheet)}
              onChange={() => {}} // Handled by card click
              disabled={disabled}
            />
            <span className="ms-2 flex-grow-1 text-truncate">{sheet}</span>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default SheetSelector;
